import { Chip } from '@mui/material';
import CasLoader from 'src/compass/shared/components/CasLoader/CasLoader';
import { usePeriodStartDateMonthYear } from 'src/compass/shared/hooks/usePeriodStartDateMonthYear';
import { Colors } from 'src/compass/shared/util/Colors';

export default function CurrentPeriodDisplay() {
  const { periodStartDate, isLoading } = usePeriodStartDateMonthYear();

  return (
    <Chip
      label={isLoading ? <CasLoader /> : periodStartDate}
      sx={{
        backgroundColor: Colors.Present,
        color: 'black',
        fontWeight: 'bold',
        ml: 2,
        fontSize: 15,
      }}
    />
  );
}
